import { useTranslate } from '@festina-life/ui/hooks'

import { useVariantAction } from '../../../hooks/useVariantAction'
import { useHook } from '../../../lenteHooks'
import { CommandModalButton } from '../../commandActions/CommandModalButton'
import type { ActionButtonProps } from '../../commandActions/types'
import { InvestmentSpecForm } from './InvestmentSpecForm'

export function InvestmentSpecCommand(props: ActionButtonProps) {
  const translate = useTranslate()

  const { tenantId, ownerId } = useHook('routing.general.useEntityParams')()
  const actions = useHook('mutators.unitlink.useInvestmentSpecActions')({
    tenantId,
    ownerId,
    ...props,
  })

  const submit = useVariantAction({ ...props, actions })

  // This command has been deprecated. But we still need the ability to cancel and update existing commands.
  if (props.commandActionVariant === 'create') {
    return null
  }

  return (
    <CommandModalButton
      actionId="unitLink.InvestmentSpecCommandData"
      title={translate('investmentSpecModalButton.title')}
      commandDataForm={InvestmentSpecForm}
      {...props}
      submit={submit}
    />
  )
}
